export const IconYoutube = () => (
  <svg width="56" height="56" viewBox="0 0 56 56" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M39.5799 34.5452C39.2862 35.8679 38.2421 36.8431 36.9857 36.9886C34.0097 37.3331 30.9976 37.3348 27.9985 37.3331C24.9996 37.3348 21.9873 37.3331 19.0115 36.9886C17.7549 36.8431 16.7113 35.8679 16.4179 34.5452C16 32.6615 16 30.606 16 28.667C16 26.7276 16.005 24.6719 16.4225 22.7881C16.7163 21.4655 17.7598 20.49 19.0162 20.3448C21.9922 20.0002 25.0043 19.9985 28.0034 20.0002C31.0023 19.9985 34.0147 20.0002 36.9904 20.3448C38.247 20.49 39.2912 21.4655 39.5846 22.7881C40.0025 24.6719 40 26.7276 40 28.667C40 30.606 39.9975 32.6615 39.5799 34.5452ZM25.8399 24.0784L32.4818 28.052L25.8399 32.0255V24.0784Z"
      fill="white"
    />
  </svg>
);
